
export const CONFIG = {
  apiUrl: "https://api-daggr.finvaultai.alphastreet.io/v1",
  workItemsApi: "https://api-workitems.finvaultai.alphastreet.io/v1",
  scraperApi: "https://api-scraper.finvaultai.alphastreet.io/v1",
  mlApi: "https://5tnlzyhipi.execute-api.us-east-1.amazonaws.com/dev-vinod",
  publishingApi: "https://api-pub.finvaultai.alphastreet.io/v1",
  ssoApi: "https://api-sso.finvaultai.alphastreet.io/v1",
  clientId: "2eb793p3uh8gp7f6hckjpurnor",
  redirectSignInUrl: "https://daggr.finvaultai.alphastreet.io/index.html",
  redirectSignOutUrl: "https://daggr.finvaultai.alphastreet.io/index.html",
  appWebDomain: "auth-ui-sso.finvaultai.alphastreet.io",
  automationAppUrl: "https://daggr-automation.finvaultai.alphastreet.io"
};
